import styled from "@emotion/styled"
import Typography from "@mui/material/Typography"
import { breakpoints } from "../../theme/mediaQueries"
import { colors } from "../../theme/colors"

/* EGDE-596: this element no longer pins itself. The bar is held at the bottom of
   the screen (EGDE-473 — QA rejected the below-the-header placement) by
   HeroStripStack in ./Stack.tsx, which lays every strip out as a column. Each
   strip being its own `position: fixed; bottom: 0` at the same z-index is exactly
   what made two of them land on top of each other. */
export const Root = styled.div<{ $clearHeader?: boolean }>`
  width: 100%;
  background-color: ${colors.light.bg.primary};
  border-top: 1px solid ${colors.primitives.neutral300};
  padding: 24px 0;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);

  @media (min-width: ${breakpoints.lg}px) {
    height: 176px;
    display: flex;
    align-items: center;
    padding: 0;
  }
`

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: ${breakpoints.lg}px) {
    gap: 24px;
  }
`

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  @media (min-width: ${breakpoints.lg}px) {
    gap: 16px;
  }
`

export const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const TitleText = styled(Typography)`
  && {
    font-weight: 700;
  }
  color: ${colors.light.text.primary};
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
  width: 24px;
  height: 24px;

  svg {
    width: 100%;
    height: 100%;
  }

  @media (min-width: ${breakpoints.lg}px) {
    width: 32px;
    height: 32px;
  }
`

export const IconWrapper = styled.span`
  display: flex;
  flex-shrink: 0;
  width: 20px;
  height: 20px;

  svg {
    width: 100%;
    height: 100%;
  }

  @media (min-width: ${breakpoints.lg}px) {
    width: 24px;
    height: 24px;
  }
`

export const IconImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

export const ContentRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: row;
    align-items: center;
    gap: 40px;
  }

  /* ESEIM-220: Match CTA button size to design.
     EGDE-491: mobile CTA hugs its label (no fixed width) with 18px text;
     the fixed 200px width applies from desktop up only. */
  .MuiButton-root {
    flex-shrink: 0;
    font-weight: 700;
    min-width: 0;
    font-size: 18px;
    line-height: 22px;

    @media (min-width: ${breakpoints.lg}px) {
      min-width: 200px;
      font-size: 20px;
      line-height: 28px;
    }
  }
`

export const BodyText = styled(Typography)`
  color: ${colors.light.text.primary};

  @media (min-width: ${breakpoints.lg}px) {
    flex: 1;
  }
`
